import { render, staticRenderFns } from "./elEvent.vue?vue&type=template&id=64935ad9&scoped=true&"
import script from "./elEvent.vue?vue&type=script&lang=js&"
export * from "./elEvent.vue?vue&type=script&lang=js&"
import style0 from "./elEvent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./elEvent.vue?vue&type=style&index=1&id=64935ad9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64935ad9",
  null
  
)

export default component.exports